import React from 'react'

import moment from 'moment'
import Badge from 'react-bootstrap/Badge'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Table from 'react-bootstrap/Table'

import { EmptyContainer } from '../EmptyContainer'
import { PageLoadingContainer } from '../PageLoadingContainer'
import { buildFundraiserPagePath } from './fundraiserUrl'

const formatCurrency = (value) => {
  const amount = Number(value)
  if (!Number.isFinite(amount)) return '-'
  return `$${amount.toLocaleString()}`
}

const formatStatus = (status) => {
  if (status === 'active') return { label: 'Active', variant: 'success' }
  if (status === 'draft') return { label: 'Draft', variant: 'secondary' }
  if (status === 'paused') return { label: 'Paused', variant: 'warning' }
  if (status === 'completed') return { label: 'Completed', variant: 'info' }
  return { label: status || 'Unknown', variant: 'light' }
}

const formatDate = (value) => {
  if (!value) return null
  const date = moment(value)
  return date.isValid() ? date.format('MM/DD/YYYY') : null
}

export default function FundraisersList({
  campaigns = [],
  isLoading,
  organizationName = '',
  onCreate,
  onEdit,
}) {
  if (isLoading) {
    return <PageLoadingContainer style="without-sidebar" />
  }

  return (
    <section className="spacer-sm fundraisers-list">
      <header className="section-heading--flex section-header-sm">
        <div className="section-heading">
          <h1>Fundraisers</h1>
          <p className="section-header-desc">
            Create and manage fundraising campaigns linked to checkout and
            public pages.
          </p>
        </div>
        <Button onClick={onCreate}>Create campaign</Button>
      </header>

      <Card body className="card--md">
        {campaigns.length === 0 ? (
          <EmptyContainer>
            <p className="mb-3">No fundraising campaigns yet.</p>
          </EmptyContainer>
        ) : (
          <div className="table-container border-bottom-0">
            <div className="table-container--fixed-height">
              <Table responsive className="mb-0">
                <thead>
                  <tr className="md md--scroll">
                    <th className="text-left uppercase text-body">Campaign</th>
                    <th className="text-left uppercase text-body">Status</th>
                    <th className="text-left uppercase text-body">
                      Connection
                    </th>
                    <th className="text-left uppercase text-body">Goal</th>
                    <th className="text-left uppercase text-body">Raised</th>
                    <th className="text-left uppercase text-body">Dates</th>
                    <th className="text-right uppercase text-body">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {campaigns.map((campaign) => {
                    const status = formatStatus(campaign.status)
                    const fundraiserPagePath = buildFundraiserPagePath(
                      organizationName,
                      campaign.slug
                    )
                    return (
                      <tr className="md-x md-x--scroll" key={campaign.uuid}>
                        <td className="text-left">
                          <div className="fundraisers-table__name">
                            {campaign.title}
                          </div>
                          {fundraiserPagePath && (
                            <div className="fundraisers-table__url">
                              {campaign.status === 'active' ? (
                                <a
                                  href={
                                    process.env.REACT_APP_CONSUMER_PORTAL +
                                    fundraiserPagePath
                                  }
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {fundraiserPagePath}
                                </a>
                              ) : (
                                fundraiserPagePath
                              )}
                            </div>
                          )}
                        </td>
                        <td className="text-left">
                          <Badge bg={status.variant}>{status.label}</Badge>
                        </td>
                        <td className="text-left">
                          {campaign.connectionType || '-'}
                        </td>
                        <td className="text-left fundraisers-table__amount">
                          {formatCurrency(campaign.goalAmount)}
                        </td>
                        <td className="text-left fundraisers-table__amount">
                          {formatCurrency(campaign.raisedAmount)}
                        </td>
                        <td className="text-left text-nowrap">
                          {formatDate(campaign.startDate) || '-'}
                          {campaign.endDate
                            ? ` to ${formatDate(campaign.endDate)}`
                            : ''}
                        </td>
                        <td className="text-right">
                          <Button
                            size="sm"
                            variant="outline-primary"
                            onClick={() => onEdit(campaign.uuid)}
                          >
                            Edit
                          </Button>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        )}
      </Card>
    </section>
  )
}
